export default __webpack_public_path__ + "static/media/pdf-icon-png-pdf-zum-download-2.7374e011.png";